import { render } from "./HeroiconsOutlinePlusCircle.vue?vue&type=template&id=ba6005f4"
const script = {}

import exportComponent from "/home/fran/Desarrollo/soyasi/ebim-crm/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlinePlusCircle.vue"]])

export default __exports__